export var reachify = function reachify(reduxHistory) {
  var transitioning = false;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  var resolveTransition = function resolveTransition() {};
  return {
    // eslint-disable-next-line no-underscore-dangle
    _onTransitionComplete: function _onTransitionComplete() {
      transitioning = false;
      resolveTransition();
    },
    listen: function listen(listener) {
      if (reduxHistory.listenObject) {
        // @ts-ignore
        return reduxHistory.listen(listener);
      }
      // @ts-ignore
      return reduxHistory.listen(function (location, action) {
        return listener({
          location: location,
          action: action
        });
      });
    },
    // @ts-ignore
    navigate: function navigate(to) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        state = _ref.state,
        _ref$replace = _ref.replace,
        replace = _ref$replace === void 0 ? false : _ref$replace;
      if (transitioning || replace) {
        reduxHistory.replace(to, state);
      } else {
        reduxHistory.push(to, state);
      }
      transitioning = true;
      // eslint-disable-next-line no-return-assign
      // @ts-ignore
      return new Promise(function (res) {
        return resolveTransition = res;
      });
    },
    // @ts-ignore
    get location() {
      return reduxHistory.location;
    },
    get transitioning() {
      return transitioning;
    }
  };
};